import { withI18n } from 'react-i18next';
import { connect } from 'react-redux';
import ArSummary from './ArSummary';
import { contentSel } from 'src/store/modules/arSummary';

const mapStateToProps = (state: any) => {
  return {
    ArSummaryContent: contentSel(state)
  };
};

export const pureComponent = ArSummary;
export default connect(mapStateToProps)(withI18n()(ArSummary));
